"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("firebase/auth");
const router_1 = require("../../routing/router");
const game_event_1 = require("../../models/game_event");
const globals_1 = require("../../infra/globals");
class NewGameEventView extends HTMLElement {
    static tag = "new-game-event-view";
    currentUser = null;
    constructor() {
        super();
        globals_1.setup.initAuth();
    }
    async connectedCallback() {
        (0, auth_1.onAuthStateChanged)(globals_1.setup.auth, (user) => {
            if (user) {
                this.currentUser = user;
                this.setNewGameEventForm();
            }
            else
                globals_1.router.manualRouting(router_1.RouteEnum.admin);
        });
    }
    type = game_event_1.GameEventTypes.tournament;
    setNewGameEventForm = () => {
        this.innerHTML = `
      <form>
        <fieldset>
          <label for="type">Tipo</label>
          <select name="type">
            <option selected value="${this.type}">Torneio</option>
            <option value="${game_event_1.GameEventTypes.league}">Liga</option>
          </select>
        </fieldset>

        <fieldset>
          <label for="name">Nome</label>
          <input 
            required 
            type="text" 
            name="name" 
            placeholder="Copa do Mundo de Go"
            autofocus/>
        </fieldset>

        <fieldset id="dates"></fieldset>

        <fieldset>
          <label for="link">Link (Opcional)</label>
          <input 
            type="text" 
            name="link"
            placeholder="https://online-go.com/game/..."/>
        </fieldset>
        
        <button type="submit">Adicionar Evento</buton>
      </form>
    `;
        const typeSelect = this.querySelector("select");
        typeSelect.onchange = this.changeDatesOnForm;
        this.changeDatesType();
        const form = this.querySelector("form");
        form.onsubmit = this.onSubmit;
    };
    changeDatesOnForm = (e) => {
        e.preventDefault();
        const typeSelect = this.querySelector("select[name=type]");
        this.type = (0, game_event_1.gameEventTypeFromString)(typeSelect.value);
        this.changeDatesType();
    };
    changeDatesType = () => {
        const dateFieldset = this.querySelector("fieldset#dates");
        if (this.type === game_event_1.GameEventTypes.league)
            dateFieldset.innerHTML = `
        <label for="date-init">Data de Início</label>
        <input required type="date" name="date-init"/>

        <label for="date-end">Data de Fim (Opcional)</label>
        <input type="date" name="date-end"/>
      `;
        else if (this.type === game_event_1.GameEventTypes.tournament) {
            dateFieldset.innerHTML = `
        <label for="">Datas do Torneio</label>
        
        <div id="dates-select" class="multi-select">
          <input type="date" name="date-1"/>
        </div>
        
        <button id="add-country-select">+</button>
      `;
            const addDateButton = this.querySelector("button#add-country-select");
            addDateButton.onclick = (e) => {
                e.preventDefault();
                const datesDiv = this.querySelector("div#dates-select");
                datesDiv.innerHTML += `
          <input type="date" name="date-${this.numberOfDatesForTournament}"/>
        `;
            };
        }
    };
    numberOfDatesForTournament = 1;
    get tournamentDates() {
        const datesDiv = this.querySelector("div#dates-select");
        const datesInputs = datesDiv.querySelectorAll("input");
        const dates = [];
        for (const input of datesInputs)
            dates.push(input.valueAsDate.getTime());
        return dates;
    }
    get name() {
        const nameInput = this.querySelector("input[name=name]");
        return nameInput.value;
    }
    get link() {
        const linkInput = this.querySelector("input[name=link]");
        return linkInput.value;
    }
    get dateInit() {
        const dateInitInput = this.querySelector("input[name=date-init]");
        return dateInitInput.valueAsDate.getTime();
    }
    get dateEnd() {
        const dateEndInput = this.querySelector("input[name=date-end]");
        return dateEndInput.valueAsDate.getTime();
    }
    onSubmit = async (e) => {
        e.preventDefault();
        let dates;
        if (this.type === game_event_1.GameEventTypes.league)
            dates = {
                type: game_event_1.GameEventTypes.league,
                dateInit: this.dateInit,
                dateEnd: this.dateEnd,
            };
        else if (this.type === game_event_1.GameEventTypes.tournament)
            dates = {
                type: game_event_1.GameEventTypes.tournament,
                dates: this.tournamentDates,
            };
        const gameEvent = {
            ...dates,
            name: this.name,
            link: this.link,
            author: {
                uid: this.currentUser?.uid,
                name: this.currentUser?.displayName,
                email: this.currentUser?.email,
            },
        };
        const userIdToken = await this.currentUser?.getIdToken();
        const res = await fetch(`${globals_1.apiUrl}${router_1.RouteEnum.gameEvents}/novo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userIdToken}`,
            },
            body: JSON.stringify(gameEvent),
        });
        const json = await res.json();
        const gameEventFromServer = json["data"]["gameEvent"];
        if (gameEventFromServer)
            this.innerHTML += `
        <div id="return-msg">
          <p>
            ${gameEventFromServer.name} adicionado(a) com sucesso!
          </p>

          <p>
            Para visualizá-lo, clique 
            <route-link 
              href="${router_1.RouteEnum.gameEvents}/${gameEventFromServer.firebaseRef}">
                aqui.
            </route-link>
          </p>
        </div>
      `;
        else
            this.innerHTML += `
        <div id="return-msg">
          <p>Não foi possível adicionar tal evento.</p>
        </div>
      `;
    };
}
exports.default = NewGameEventView;
//# sourceMappingURL=data:application/json;base64,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